import React from 'react'
import Modal from '@material-ui/core/Modal'
import { createStyles, makeStyles } from '@material-ui/core/styles'

import { ReactComponent as CloseIcon } from '../img/cross-close.svg'

interface StyledModalProps {
  open: boolean
  setOpen: (open: boolean) => void
  content: React.FC
}

function getModalStyle() {
  const top = 50
  const left = 50
  return {
    top: `${top}%`,
    left: `${left}%`,
    transform: `translate(-${top}%, -${left}%)`,
  }
}

const useStyles = makeStyles(() =>
  createStyles({
    paper: {
      position: 'absolute',
      backgroundColor: '#FFFFFF',
      boxShadow: '0px 8px 12px rgba(0, 0, 0, 0.12)',
      borderRadius: '4px',
      width: 'calc(100% - 48px)',
      maxWidth: '800px',
    },
    button: {
      background: 'transparent',
      border: 'none',
      width: '36px',
      height: '36px',
      position: 'absolute',
      right: '16px',
      top: '16px',
      padding: '0',
      cursor: 'pointer',
    },
  }),
)

export const StyledModal: React.FC<StyledModalProps> = ({ open, setOpen, content: Child }) => {
  const classes = useStyles()
  const [modalStyle] = React.useState(getModalStyle)

  return (
    <Modal open={open} onClose={() => setOpen(false)}>
      <div>
        <div style={modalStyle} className={classes.paper}>
          <button
            type="button"
            aria-label="Close modal"
            data-testid="close-modal-button"
            className={classes.button}
            onClick={() => setOpen(false)}
          >
            <CloseIcon />
          </button>
          <Child />
        </div>
      </div>
    </Modal>
  )
}

export default StyledModal
